import { fetchBasesAction } from "./actions";
import { push } from "connected-react-router";
import { FirebaseTimestamp, db } from "../../firebase";
import {
  collection,
  doc,
  getDocs,
  deleteDoc,
  orderBy,
  updateDoc,
  addDoc,
  query,
} from "firebase/firestore";

export const saveBases = (newBases) => {
  return async (dispatch) => {
    const bases = await fetchBasesWithNoRedux();
    const timestamp = FirebaseTimestamp.now();
    const batch = [];

    // 1. basesに存在し、newBasesに存在しないカテゴリを削除
    bases.forEach((base) => {
      const baseExistsInNew = newBases.some(
        (newBase) => newBase.id === base.id
      );
      if (!baseExistsInNew) {
        //存在しなかったら
        const docRef = doc(db, "bases", base.id);
        batch.push(deleteDoc(docRef));
      }
    });

    // 2. newBasesに存在し、basesに存在しないカテゴリを追加
    newBases.forEach((newBase) => {
      const baseExistsInbases = bases.some((base) => base.id === newBase.id);
      if (!baseExistsInbases) {
        //存在しなかったら
        const data = {
          id: "",
          bid: newBase.bid,
          name: newBase.name,
          updated_at: timestamp,
          created_at: timestamp,
        };
        batch.push(addNewDocument(data));
      }
    });

    // 3. basesとnewBasesの両方に存在するカテゴリを更新
    newBases.forEach((newBase) => {
      const baseExistsInbases = bases.some((base) => base.id === newBase.id);
      if (baseExistsInbases) {
        const baseToUpdate = bases.find((base) => base.id === newBase.id);
        if (JSON.stringify(baseToUpdate) !== JSON.stringify(newBase)) {
          const docRef = doc(db, "bases", newBase.id);
          const data = {
            id: newBase.id,
            bid: newBase.bid,
            name: newBase.name,
            updated_at: timestamp,
          };
          batch.push(updateDoc(docRef, data, { merge: true }));
        }
      }
    });

    try {
      await Promise.all(batch);
      dispatch(push("/ordering-department/menu"));
    } catch (error) {
      console.error("Error synchronizing bases: ", error);
      throw new Error(error);
    }
  };
};

const addNewDocument = async (newData) => {
  const collectionRef = collection(db, "bases");

  try {
    const docRef = await addDoc(collectionRef, newData);
    const newDocumentId = docRef.id;
    const newDataWithId = { ...newData, id: newDocumentId };
    const docRefToUpdate = doc(db, "bases", newDocumentId);
    await updateDoc(docRefToUpdate, newDataWithId);
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};

export const fetchbases = () => {
  return async (dispatch) => {
    const q = query(collection(db, "bases"), orderBy("bid", "asc"));
    const querySnapshot = await getDocs(q);
    const list = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      list.push({
        id: data.id,
        bid: data.bid,
        name: data.name,
      });
    });
    console.log("list:", list);
    dispatch(fetchBasesAction(list));
  };
};

const fetchBasesWithNoRedux = async () => {
  const q = query(collection(db, "bases"), orderBy("id", "asc"));
  const querySnapshot = await getDocs(q);
  const list = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    list.push({
      id: doc.id,
      bid: data.bid,
      name: data.name,
    });
  });
  return list;
};
